export default "__VITE_ASSET__5a161555__"